export default __webpack_public_path__ + "static/media/rectangles-no-8.ba50fbfe.mid";